// Quick capture's Concept target (docs/areas/learn.md): a line becomes a Concept, new, in the suite.
import { mutate as runtimeMutate } from '@/runtime'
import type { Mutator } from '@/db/ops'
import { WS } from '@/db/ops'
import { DEFAULT_WORKSPACE_SLUG } from '@/kinds/workspace/schema'
import type { ConceptResource } from '@/kinds/learn/apply'
import type { ConceptSpec } from '@/kinds/learn/schema'

/** "Name" or "Name: what it is in a line". The name stops at the first colon followed by a space. */
export const parseConcept = (line: string): Pick<ConceptSpec, 'name' | 'one_liner'> | null => {
  const text = line.trim()
  if (!text) return null
  const at = text.indexOf(': ')
  const name = (at < 0 ? text : text.slice(0, at)).trim()
  const one = at < 0 ? '' : text.slice(at + 2).trim()
  if (!name) return null
  return one ? { name: name.slice(0, 200), one_liner: one.slice(0, 500) } : { name: name.slice(0, 200) }
}

/** Creates a Concept for each non-empty line; returns what was made. */
export const addConcepts = async (
  lines: string[],
  ws: string = DEFAULT_WORKSPACE_SLUG,
  mutate: Mutator = runtimeMutate,
): Promise<ConceptResource[]> => {
  const made: ConceptResource[] = []
  await mutate.grouped(async () => {
    for (const line of lines) {
      const spec = parseConcept(line)
      if (spec) made.push((await mutate.create('Concept', spec, { [WS]: ws })) as ConceptResource)
    }
  })
  return made
}
